<template>
  <div class="pc_brand-tab">
    <div class="brand-main">
      <div class="brand-title">
        <div class="title-div">{{ $t('PCBrandTab.index') }}:</div>
      </div>

      <PC-scroll-tab :list="brandList" :active="active" @handleSetActive="onTab" />
      <!-- <el-popover placement="bottom" trigger="hover">
        <div></div>
        <div slot="reference" class="brandListBox">
          <PC-scroll-tab :list="brandList" :active="active" @handleSetActive="onTab" />
        </div>
      </el-popover> -->
    </div>
  </div>
</template>

<script>
import PCScrollTab from '@/components/PCScrollTab/index2.vue';
export default {
  name: 'PCBrandTab',
  components: {
    PCScrollTab
  },
  props: {
    brandList: Array
  },
  data() {
    return {
      active: 0
    };
  },
  computed: {
    brandData() {
      return this.brandList;
    }
  },
  methods: {
    onTab(item) {
      const { brandId, index } = item;
      this.active = index;
      this.$emit('onChange', brandId);
    }
  }
};
</script>

<style scoped lang="less">
.pc_brand-tab {
  background-color: #fff;
  // height: 72px;
  border-radius: 0 0 8px 8px;
  overflow: hidden;
  .brand-main {
    width: 100%;
    // height: 100%;
    display: flex;
    .brand-title {
      width: 165px;
      padding: 25px 0px 25px 40px;
    }
    .brandListBox {
      width: 1000px;
      height: 100%;
      overflow-x: hidden;
    }
    .title-div {
      color: #6e6e6e;
      font-size: 16px;
    }
    .brand-right {
      flex: 1;
      display: flex;
    }
  }
}
</style>
